<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="card-title mb-0">
          Pótmunka rögzítése
        </h4>
      </div>

      <b-form @submit.prevent="submitAdditionalWork">
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Projekt kiválasztása"
              label-for="project-select"
            >
              <b-form-select
                id="project-select"
                v-model="selectedProjectId"
                :options="projectOptions"
                value-field="id"
                text-field="name"
                :disabled="loading"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Válassz projektet --
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Pótmunka leírása"
              label-for="description"
            >
              <b-form-textarea
                id="description"
                v-model="extraWorkDescription"
                rows="4"
                placeholder="Írja le a pótmunka részleteit..."
                :disabled="loading"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <div class="d-flex justify-content-end">
              <b-button
                type="submit"
                variant="primary"
                :disabled="!selectedProjectId || !extraWorkDescription.trim() || loading"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="mr-1"
                />
                {{ loading ? 'Rögzítés...' : 'Pótmunka rögzítése' }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormGroup,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BButton,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'AddAdditionalWork',
  components: {
    BCard,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BFormTextarea,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  data() {
    return {
      selectedProjectId: null,
      extraWorkDescription: '',
      projectOptions: [],
      loading: false,
    }
  },
  mounted() {
    this.loadProjects()
  },
  methods: {
    async loadProjects() {
      try {
        const response = await axios({
          method: 'get',
          url: 'project/list',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        })

        this.projectOptions = response.data
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt a projektek betöltése során',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      }
    },
    async submitAdditionalWork() {
      if (!this.selectedProjectId || !this.extraWorkDescription.trim()) {
        return
      }

      this.loading = true

      try {
        await axios({
          method: 'post',
          url: 'project/create/additional-work',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          data: {
            project_id: this.selectedProjectId,
            extra_work: this.extraWorkDescription.trim(),
          },
        })

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Pótmunka sikeresen rögzítve',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })

        // Reset form
        this.selectedProjectId = null
        this.extraWorkDescription = ''
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Hiba történt a pótmunka rögzítése során'

        this.$toast({
          component: ToastificationContent,
          props: {
            title: errorMessage,
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.card-title {
  color: #6e6b7b;
  font-weight: 600;
}
</style>
